import React, { Component } from 'react'
import { SearchBarTable } from 'hljd'
import { observer } from 'mobx-react'
import getColumns from './columns'
import { inject } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  render() {
    return (
      <SearchBarTable
        columns={getColumns(this.props.store)}
        store={this.props.store}
        style={{ marginTop: 20 }}
      />
    )
  }
}
